import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { LendingOutboundPackageVolumeByProductMonthlyListChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { useInsightFetchRange } from '../../../analytics/insights/insight-detail/use-insight-fetch-range';
import { getLast60DaysChartRange } from '../../pudo/last-30-days-chart-range';
import { Last60DaysLendingOutboundPackageVolumeByProductMonthlyListChartProps } from './last-60-days-lending-outbound-package-volume-by-product-monthly-list-chart.component';

export const useLast60DaysLendingOutboundPackageVolumeByProductMonthlyListChart = (
    props: Last60DaysLendingOutboundPackageVolumeByProductMonthlyListChartProps
) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast60DaysChartRange);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;

        ChartClient.fetchChartData(props.accountId, LendingOutboundPackageVolumeByProductMonthlyListChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId, fetchRange.key]);

    return { data, isLoading };
};
